import type { SVGProps } from 'react';

const TrendingUp = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.16667 7.49998L6.83333 3.83331"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.83333 12.8334H4.16667C4.53486 12.8334 4.83333 12.535 4.83333 12.1668V10.5C4.83333 10.1318 4.53486 9.83331 4.16667 9.83331H3.83333C3.46515 9.83331 3.16667 10.1318 3.16667 10.5V12.1668C3.16667 12.535 3.46515 12.8334 3.83333 12.8334Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.83333 12.8334H8.16667C8.53487 12.8334 8.83333 12.535 8.83333 12.1668V8.49998C8.83333 8.13178 8.53487 7.83331 8.16667 7.83331H7.83333C7.46513 7.83331 7.16667 8.13178 7.16667 8.49998V12.1668C7.16667 12.535 7.46513 12.8334 7.83333 12.8334Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.8333 12.8335H12.1667C12.5349 12.8335 12.8333 12.535 12.8333 12.1668V3.83335C12.8333 3.46517 12.5349 3.16669 12.1667 3.16669H11.8333C11.4651 3.16669 11.1667 3.46517 11.1667 3.83335V12.1668C11.1667 12.535 11.4651 12.8335 11.8333 12.8335Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 5.50002V3.16669H5.16667"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default TrendingUp;
